import { Map } from 'immutable';

import {
  DELETE_CAMERA_INTERFACE_CONTROLLER,
  RECEIVE_CAMERA_INTERFACE_CONTROLLERS,
  REQUEST_CAMERA_INTERFACE_CONTROLLER,
} from '@sophocles/entities/CameraInterfaceController/cameraInterfaceControllerActions';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_CAMERA_INTERFACE_CONTROLLERS: // Read
      return state.merge(action.cameraInterfaceControllers);
    case DELETE_CAMERA_INTERFACE_CONTROLLER: // Socket delete
      return state.delete(action.cameraInterfaceController.toString());
    case REQUEST_CAMERA_INTERFACE_CONTROLLER:
    default:
      return state;
  }
}

export function cameraInterfaceControllerReducer(state = Map(), action) {
  switch (action.type) {
    case DELETE_CAMERA_INTERFACE_CONTROLLER:
    case RECEIVE_CAMERA_INTERFACE_CONTROLLERS:
    case REQUEST_CAMERA_INTERFACE_CONTROLLER:
      return getState(state, action);
    default:
      return state;
  }
}
